<template>
  <div id="functionToolbox">
    <div class="operator" @click="addItem('+')">
      <div class="symbol float-left">+</div>
      <div class="name float-right">Concatenate Models</div>
      <div class="clearfix"></div>
      <p class="description font14">Combine the values of two or more models.</p>
      <p class="example font14">Example: <span class="exampleText">first_name + last_name</span></p>
    </div>

    <div class="operator" @click="addItem('cap(fieldName')">
      <div class="symbol float-left">cap(fieldName)</div>
      <div class="name float-right">Capitalize Model</div>
      <div class="clearfix"></div>
      <p class="description font14">Capitalizes the first letter of a single word.</p>
      <p class="example font14">Example: <span class="exampleText">cap(first_name)</span></p>
    </div>

    <div class="operator" @click="addItem('capwords(fieldName)')">
      <div class="symbol float-left">capwords(field)</div>
      <div class="name float-right">Capitalize Words</div>
      <div class="clearfix"></div>
      <p class="description font14">Capitalize the first letter of each word.</p>
      <p class="example font14">Example: <span class="exampleText">capwords(client_address_verbose)</span></p>
    </div>

    <div class="operator" @click="addItem('getCh(1, 1, fieldName)')">
      <div class="symbol float-left">getCh(A, B, field)</div>
      <div class="name float-right">Get Character</div>
      <div class="clearfix"></div>
      <p class="description font14">Gets a range of characters starting at index A, up through index B.</p>
      <p class="example font14">Example: <span class="exampleText">getCh(1, 1, client_bio_weight_full)</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'function-toolbox',

  methods: {
    addItem (symbol) {
      this.$parent.$emit('addItem', symbol)
    }
  }
}
</script>

<style lang="scss" scoped>
  #functionToolbox {
    display:block;
    width: 100%;
    height: 300px;
    overflow-y: scroll;
    border: 1px solid black;

    .operator {
      cursor: pointer;
      border-bottom: 1px solid black;
      &:hover {
        background-color: #DDD;
      }
    }

    .symbol, .name {
      padding: 10px;
    }

    .name, .symbol {
      font-size: 20px;
      line-height: 14px;
    }

    .symbol {
      font-weight: bold;
    }

    .description {
      margin: 0;
      padding: 0 10px 0 10px;
    }

    .example {
      padding: 0 10px 0 10px;
      font-weight: bold;

      .exampleText {
        font-weight: normal;
      }
    }
  }

  .font14{
    font-size: 14px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/modal-edit/FunctionToolbox.vue